import React from "react";
import styles from "./contentcard.module.css";

type ContentCardProps = {
  title: string;
  imageUrl?: string;
  subTitle?: string;
  description?: string;
};

const ContentCard = ({
  title,
  imageUrl,
  subTitle,
  description,
}: ContentCardProps) => {
  return (
    <div className={styles.contentCard}>
      {imageUrl && <img src={imageUrl} alt="Corti logo" width="80" />}
      <h1>{title}</h1>
      {subTitle && <h3>{subTitle}</h3>}
      {description && <p>{description}</p>}
    </div>
  );
};

export default ContentCard;
